// import { showAlert } from './alerts.js';

// console.log('hello from manageStore.js  ');

// const createStore = (currentUserId, data) => {
//   axios
//     .post(`/api/v1/users/${currentUserId}/store`, data)
//     .then(res => {
//       if (res.data.status === 'success') {
//         showAlert('success', 'Success', ' Boutique créé avec succès !');
//         window.setTimeout(() => {
//           // location.assign("/store-signup");
//           location.reload();
//         }, 2000);
//       }
//     })
//     .catch(err => {
//       showAlert('danger', 'Alert', err.response.data);
//     });
// };

// const updateStore = (data, currentUserId, currentStoreId) => {
//   axios
//     .patch(`/api/v1/users/${currentUserId}/store/${currentStoreId}`, data)
//     .then(res => {
//       if (res.data.status === 'success') {
//         showAlert('success', 'Success', ' Boutique à jour avec succès !');
//         window.setTimeout(() => {
//           // location.assign("/editstore");
//           location.reload();
//         }, 2000);
//       }
//     })
//     .catch(err => {
//       console.log('Error : ' + err);
//       showAlert('danger', 'Alert', err.response.data);
//     });
// };

// const addStoreReview = (storeId, review, rating) => {
//   axios
//     .post(`/api/v1/stores/${storeId}/reviews`, {
//       review,
//       rating,
//     })
//     .then(res => {
//       if (res.data.status === 'success') {
//         showAlert('success', 'Success', ' Boutique ajouté avec succès !');
//         window.setTimeout(() => {
//           location.reload();
//           // location.assign(location.pathname + "#commentaires");
//         }, 2000);
//       }
//     })
//     .catch(err => {
//       showAlert('danger', 'Alert', err.response.data);
//     });
// };
// const updateStoreReview = (
//   storeId,
//   currentUserStoreReviewId,
//   review,
//   rating
// ) => {
//   axios
//     .patch(`/api/v1/stores/${storeId}/reviews/${currentUserStoreReviewId}`, {
//       review,
//       rating,
//     })
//     .then(res => {
//       if (res.data.status === 'success') {
//         showAlert('success', 'Success', ' Avis mis à jour avec succès !');
//         window.setTimeout(() => {
//           location.reload();
//           // location.assign(location.pathname + "#commentaires");
//         }, 2000);
//       }
//     })
//     .catch(err => {
//       showAlert('danger', 'Alert', err.response.data);
//     });
// };

// const deleteStoreReview = (storeId, currentUserStoreReviewId) => {
//   axios
//     .delete(`/api/v1/stores/${storeId}/reviews/${currentUserStoreReviewId}`)
//     .then(res => {
//       // console.log("deleted", res);
//       // if (res.data.status === "success") {
//       showAlert('success', 'Success', ' Avis supprimé avec succès !');
//       window.setTimeout(() => {
//         // location.assign(location.pathname + "#commentaires");
//         location.reload();
//       }, 2000);
//     })
//     .catch(err => {
//       showAlert('danger', 'Alert', err.response.data);
//     });
// };

// const adminDeleteStoreReview = currentStoreReviewId => {
//   axios
//     .delete(`/api/v1/reviews/${currentStoreReviewId}`)
//     .then(res => {
//       // console.log("deleted", res);
//       // if (res.data.status === "success") {
//       showAlert('success', 'Success', ' Avis supprimé avec succès !');
//       window.setTimeout(() => {
//         // location.assign(location.pathname + "#commentaires");
//         location.reload();
//       }, 2000);
//     })
//     .catch(err => {
//       showAlert('danger', 'Alert', err.response.data);
//     });
// };

// const createStoreForm = document.getElementById('create-store-form');
// const updateStoreForm = document.getElementById('update-store-form');
// const addStoreReviewBtn = document.getElementById('add-store-review-btn');
// const updateStoreReviewBtn = document.getElementById('update-store-review-btn');
// const deleteStoreReviewBtn = document.getElementById('delete-store-review-btn');
// const adminDeleteStoreReviewBtn = $('.admin-delete-store-review-btn');

// if (createStoreForm) {
//   try {
//     createStoreForm.addEventListener('submit', e => {
//       e.preventDefault();

//       showAlert(
//         'primary',
//         'Yay !',
//         ' Création de votre magasin, veuillez patienter ...'
//       );

//       // alert("clicked update preference !!!!");

//       const name = document.getElementById('storename').value;
//       const slogan = document.getElementById('slogan').value;
//       const ownerName = document.getElementById('ownername').value;
//       const email = document.getElementById('storemail').value;
//       const storePhone = document.getElementById('storephone').value;
//       // const delivery = document.querySelector(
//       //   "input[type=radio][name=delivery]:checked",
//       // ).value;
//       const city = document.getElementById('storecity').value;
//       const municipality = document.getElementById('storemunicipality').value;
//       // const category = Array.from(document.getElementsByName("storecategory")).filter(e => e.checked).map(e => e.value);
//       const category = Array.from(
//         document.querySelectorAll(
//           'input[type=checkbox][name=storecategory]:checked'
//         ),
//         e => e.value
//       );
//       const description = document.getElementById('storedescription').value;
//       const photo = document.getElementById('file-upload').files[0];

//       const password = document.getElementById('ownerpassword').value;
//       const passwordConfirm = document.getElementById(
//         'ownerpasswordConfirm'
//       ).value;
//       const currentUserId = document.getElementById('currentUserId').value;

//       const data = new FormData();
//       data.append('name', name);
//       data.append('slogan', slogan);
//       data.append('ownerName', ownerName);
//       data.append('email', email);
//       data.append('storePhone', storePhone);
//       // data.append("delivery", delivery);
//       data.append('city', city);
//       data.append('municipality', municipality);
//       category.forEach(cat => {
//         data.append('category', cat);
//       });
//       // data.append("category", category);
//       data.append('description', description);
//       data.append('password', password);
//       data.append('passwordConfirm', passwordConfirm);

//       data.append('currentUserId', currentUserId);
//       data.append('photo', photo);

//       // Display data values
//       // for (var key of data.entries()) {
//       //   console.log(key[0] + " : " + key[1]);
//       // }

//       createStore(currentUserId, data);
//     });
//   } catch (e) {
//     console.error(e.message);
//     showAlert('danger', 'Alert !', e.message);
//   }
// }

// if (addStoreReviewBtn) {
//   addStoreReviewBtn.addEventListener('click', () => {
//     const storeReview = document.getElementById('storeReview').value;
//     const storeId = document.getElementById('storeId').value;
//     const storeRating = document.querySelector(
//       'input[name="newRating"]:checked'
//     ).value;
//     // const storeRating = document.getElementById("product-rating").value;
//     if (!storeReview.trim()) return alert('Veuillez écrire un avis.');
//     showAlert('primary', 'Yay !', 'Updating Your Review ...');
//     addStoreReview(storeId, storeReview, storeRating);
//   });
// }
// if (updateStoreReviewBtn) {
//   updateStoreReviewBtn.addEventListener('click', () => {
//     showAlert('primary', 'Yay !', 'Mise à jour de votre avis...');
//     const storeReview = document.getElementById('storeReview').value;
//     const storeId = document.getElementById('storeId').value;
//     const storeRating = document.querySelector(
//       'input[name="editRating"]:checked'
//     ).value;
//     const currentUserStoreReviewId = document.getElementById(
//       'currentUserStoreReviewId'
//     ).value;

//     updateStoreReview(
//       storeId,
//       currentUserStoreReviewId,
//       storeReview,
//       storeRating
//     );
//   });
// }
// if (deleteStoreReviewBtn) {
//   deleteStoreReviewBtn.addEventListener('click', () => {
//     showAlert('primary', 'Yay !', 'Suppression de votre avis ...');
//     const storeId = document.getElementById('storeId').value;
//     const currentUserStoreReviewId = document.getElementById(
//       'currentUserStoreReviewId'
//     ).value;
//     document.getElementById('storeReview').value = '';

//     deleteStoreReview(storeId, currentUserStoreReviewId);
//   });
// }

// if (adminDeleteStoreReviewBtn) {
//   adminDeleteStoreReviewBtn.on('click', function () {
//     showAlert('primary', 'Yay !', 'Suppression de votre avis...');
//     const currentStoreReviewId = $(this).data('id');

//     adminDeleteStoreReview(currentStoreReviewId);
//   });
// }

// if (updateStoreForm) {
//   updateStoreForm.addEventListener('submit', e => {
//     e.preventDefault();

//     showAlert(
//       'primary',
//       'Yay !',
//       ' Mise à jour de votre avis, veuillez attendre ...'
//     );

//     // alert("clicked update preference !!!!");

//     const name = document.getElementById('storename').value;
//     console.log('>>>> : ', name);
//     const slogan = document.getElementById('slogan').value;
//     const ownerName = document.getElementById('ownername').value;
//     const email = document.getElementById('storemail').value;
//     const storePhone = document.getElementById('storephone').value;
//     const delivery = document.querySelector(
//       'input[type=radio][name=delivery]:checked'
//     ).value;
//     const city = document.getElementById('storecity').value;
//     const municipality = document.getElementById('storemunicipality').value;
//     // const category = Array.from(document.getElementsByName("storecategory")).filter(e => e.checked).map(e => e.value);
//     const category = Array.from(
//       document.querySelectorAll(
//         'input[type=checkbox][name=storecategory]:checked'
//       ),
//       e => e.value
//     );
//     // console.log("category : ", category);
//     // alert("category : ", category);
//     const photo = document.getElementById('file-upload-uStore').files[0];
//     const description = document.getElementById('storedescription').value;
//     const currentUserId = document.getElementById('currentUserId').value;
//     const currentStoreId = document.getElementById('currentStoreId').value;

//     // updateStore(
//     //   currentUserId,
//     //   currentStoreId,
//     //   name
//     // slogan,
//     // ownerName,
//     // email,
//     // storePhone,
//     // city,
//     // delivery,
//     // category,
//     // description
//     // );

//     const data = new FormData();
//     data.append('name', name);
//     data.append('slogan', slogan);
//     data.append('ownerName', ownerName);
//     data.append('email', email);
//     data.append('storePhone', storePhone);
//     category.forEach(cat => {
//       data.append('category', cat);
//     });
//     data.append('delivery', delivery);
//     data.append('city', city);
//     data.append('municipality', municipality);
//     data.append('description', description);

//     data.append('currentUserId', currentUserId);
//     data.append('currentStoreId', currentStoreId);
//     data.append('photo', photo);
//     // for (var key of data.entries()) {
//     //   console.log(key[0] + " : " + key[1]);
//     // }

//     updateStore(data, currentUserId, currentStoreId);
//   });
// }

import { showAlert } from './alerts.js';

// ============================================================
//  API HELPERS
// ============================================================

const apiRequest = async (method, url, data = null) => {
  try {
    const config = {
      method,
      url,
      data,
      headers:
        data instanceof FormData
          ? undefined
          : { 'Content-Type': 'application/json' },
    };
    const response = await axios(config);
    return response.data;
  } catch (err) {
    const message =
      err.response?.data?.message || err.message || 'Une erreur est survenue.';
    showAlert('danger', 'Alert', message);
    throw err; // Re-throw so callers can handle if needed
  }
};

// ============================================================
//  BUSINESS LOGIC FUNCTIONS
// ============================================================

const createStore = (currentUserId, data) =>
  apiRequest('post', `/api/v1/users/${currentUserId}/store`, data).then(() => {
    showAlert('success', 'Succès', 'Boutique créée avec succès !');
    setTimeout(() => location.reload(), 2000);
  });

const updateStore = (data, currentUserId, currentStoreId) =>
  apiRequest(
    'patch',
    `/api/v1/users/${currentUserId}/store/${currentStoreId}`,
    data
  ).then(() => {
    showAlert('success', 'Succès', 'Boutique mise à jour !');
    setTimeout(() => location.reload(), 2000);
  });

const addStoreReview = (storeId, review, rating) =>
  apiRequest('post', `/api/v1/stores/${storeId}/reviews`, {
    review,
    rating,
  }).then(() => {
    showAlert('success', 'Succès', 'Avis ajouté !');
    setTimeout(() => location.reload(), 2000);
  });

const updateStoreReview = (storeId, reviewId, review, rating) =>
  apiRequest('patch', `/api/v1/stores/${storeId}/reviews/${reviewId}`, {
    review,
    rating,
  }).then(() => {
    showAlert('success', 'Succès', 'Avis mis à jour !');
    setTimeout(() => location.reload(), 2000);
  });

const deleteStoreReview = (storeId, reviewId) =>
  apiRequest('delete', `/api/v1/stores/${storeId}/reviews/${reviewId}`).then(
    () => {
      showAlert('success', 'Succès', 'Avis supprimé !');
      setTimeout(() => location.reload(), 2000);
    }
  );

const adminDeleteStoreReview = reviewId =>
  apiRequest('delete', `/api/v1/reviews/${reviewId}`).then(() => {
    showAlert('success', 'Succès', 'Avis supprimé par l’admin !');
    setTimeout(() => location.reload(), 2000);
  });

// ============================================================
//  FORM/EVENT HANDLERS (Static)
// ============================================================

// 1. Create Store Form
const createStoreForm = document.getElementById('create-store-form');
if (createStoreForm) {
  createStoreForm.addEventListener('submit', async e => {
    e.preventDefault();

    showAlert('primary', 'Yay !', 'Création du magasin en cours...');

    const data = new FormData(createStoreForm);
    const currentUserId = data.get('currentUserId');

    // Additional fields not in the form? Actually they are in the form, but we need to handle category as multiple.
    // The form already has inputs with names, so we can just use FormData directly.
    // However, we had custom logic for category (multiple checkboxes). We'll append them manually.
    // Let's keep the manual append for clarity.

    // Better: use FormData from the form, but the category checkboxes are named "storecategory".
    // We'll still use the manual method for consistency.
    // Let's re-use the existing manual collection:

    const name = document.getElementById('storename').value;
    const slogan = document.getElementById('slogan').value;
    const ownerName = document.getElementById('ownername').value;
    const email = document.getElementById('storemail').value;
    const storePhone = document.getElementById('storephone').value;
    const city = document.getElementById('storecity').value;
    const municipality = document.getElementById('storemunicipality').value;
    const category = Array.from(
      document.querySelectorAll(
        'input[type=checkbox][name=storecategory]:checked'
      ),
      e => e.value
    );
    const description = document.getElementById('storedescription').value;
    const photo = document.getElementById('file-upload').files[0];
    const password = document.getElementById('ownerpassword').value;
    const passwordConfirm = document.getElementById(
      'ownerpasswordConfirm'
    ).value;

    const formData = new FormData();
    formData.append('name', name);
    formData.append('slogan', slogan);
    formData.append('ownerName', ownerName);
    formData.append('email', email);
    formData.append('storePhone', storePhone);
    formData.append('city', city);
    formData.append('municipality', municipality);
    category.forEach(cat => formData.append('category', cat));
    formData.append('description', description);
    formData.append('password', password);
    formData.append('passwordConfirm', passwordConfirm);
    formData.append('currentUserId', currentUserId);
    if (photo) formData.append('photo', photo);

    await createStore(currentUserId, formData);
  });
}

// 2. Update Store Form
const updateStoreForm = document.getElementById('update-store-form');
if (updateStoreForm) {
  updateStoreForm.addEventListener('submit', async e => {
    e.preventDefault();

    showAlert('primary', 'Yay !', 'Mise à jour du magasin...');

    const currentUserId = document.getElementById('currentUserId').value;
    const currentStoreId = document.getElementById('currentStoreId').value;

    const name = document.getElementById('storename').value;
    const slogan = document.getElementById('slogan').value;
    const ownerName = document.getElementById('ownername').value;
    const email = document.getElementById('storemail').value;
    const storePhone = document.getElementById('storephone').value;
    const delivery =
      document.querySelector('input[type=radio][name=delivery]:checked')
        ?.value || '';
    const city = document.getElementById('storecity').value;
    const municipality = document.getElementById('storemunicipality').value;
    const category = Array.from(
      document.querySelectorAll(
        'input[type=checkbox][name=storecategory]:checked'
      ),
      e => e.value
    );
    const description = document.getElementById('storedescription').value;
    const photo = document.getElementById('file-upload-uStore').files[0];

    const data = new FormData();
    data.append('name', name);
    data.append('slogan', slogan);
    data.append('ownerName', ownerName);
    data.append('email', email);
    data.append('storePhone', storePhone);
    category.forEach(cat => data.append('category', cat));
    data.append('delivery', delivery);
    data.append('city', city);
    data.append('municipality', municipality);
    data.append('description', description);
    data.append('currentUserId', currentUserId);
    data.append('currentStoreId', currentStoreId);
    if (photo) data.append('photo', photo);

    await updateStore(data, currentUserId, currentStoreId);
  });
}

// ============================================================
//  EVENT DELEGATION FOR DYNAMIC BUTTONS
// ============================================================

// We'll use a common parent container (e.g., document.body) to listen for clicks.
// All dynamic buttons have specific data attributes or IDs.

document.addEventListener('click', async e => {
  const target = e.target.closest('button'); // or specific selectors

  if (!target) return;

  // --- Add Review Button ---
  if (target.id === 'add-store-review-btn') {
    e.preventDefault();
    const storeId = document.getElementById('storeId')?.value;
    const review = document.getElementById('storeReview')?.value;
    const ratingEl = document.querySelector('input[name="newRating"]:checked');
    if (!review?.trim()) {
      showAlert('warning', 'Attention', 'Veuillez écrire un avis.');
      return;
    }
    const rating = ratingEl?.value || 0;
    showAlert('primary', 'Yay !', 'Ajout de votre avis...');
    await addStoreReview(storeId, review, rating);
  }

  // --- Update Review Button ---
  if (target.id === 'update-store-review-btn') {
    e.preventDefault();
    const storeId = document.getElementById('storeId')?.value;
    const review = document.getElementById('storeReview')?.value;
    const ratingEl = document.querySelector('input[name="editRating"]:checked');
    const reviewId = document.getElementById('currentUserStoreReviewId')?.value;
    if (!review?.trim()) {
      showAlert('warning', 'Alert', 'Veuillez écrire un avis.');
      return;
    }
    const rating = ratingEl?.value || 0;
    showAlert('primary', 'Yay !', 'Mise à jour de votre avis...');
    await updateStoreReview(storeId, reviewId, review, rating);
  }

  // --- Delete Review Button (user) ---
  if (target.id === 'delete-store-review-btn') {
    e.preventDefault();
    const storeId = document.getElementById('storeId')?.value;
    const reviewId = document.getElementById('currentUserStoreReviewId')?.value;
    document.getElementById('storeReview').value = '';
    showAlert('primary', 'Yay !', 'Suppression de votre avis...');
    await deleteStoreReview(storeId, reviewId);
  }

  // --- Admin Delete Review Button (dynamic, uses data-id) ---
  if (target.classList.contains('admin-delete-store-review-btn')) {
    e.preventDefault();
    const reviewId = target.dataset.id;
    if (!reviewId) return;
    showAlert('primary', 'Yay !', 'Suppression de l’avis...');
    await adminDeleteStoreReview(reviewId);
  }
});

// ============================================================
//  RATING DISPLAY UPDATER
// ============================================================

/**
 * Updates the rating display text when a user selects a rating
 * @param {HTMLInputElement} input - The radio input that was changed
 */
// function updateRatingDisplay(input) {
//   const targetId = input.getAttribute('data-rating-target');
//   if (!targetId) return;

//   const displayElement = document.getElementById(targetId);
//   if (!displayElement) return;

//   const value = parseFloat(input.value);
//   displayElement.textContent = `${value} / 5`;
// }

// ============================================================
//  ALTERNATIVE: Event Delegation (if you prefer)
// ============================================================

// If you want to use event delegation instead of inline onchange:
document.addEventListener('change', function (e) {
  const input = e.target.closest('.rating__input');
  if (!input) return;

  const targetId = input.getAttribute('data-rating-target');
  if (!targetId) return;

  const displayElement = document.getElementById(targetId);
  if (!displayElement) return;

  const value = parseFloat(input.value);
  displayElement.textContent = `${value} / 5`;
});

console.log('manageStore.js loaded');
